<template>
    <v-card outlined>
        <!--encabezado-->
        <EncabezadoCard
                :titulo="'Acerca de'"
                :sub-titulo="'Equipo de desarrollo'"
                :icono="'mdi-laptop'"
        ></EncabezadoCard>
        <!--fin encabezado-->

        <!-- contenido-->
        <v-card-text>
          <p>
            <strong>Yaku</strong>SeLA es una plataforma web para la administración y control de los procesos realizados por el Servicio Local de Acueductos y
            Alcantarillado SELA ORURO, y fue desarrollado por la unidad de Sistemas.
          </p>

          <v-list>
            <v-subheader>Equipo Desarrollador:</v-subheader>

            <v-list-item>
              <v-list-item-content>
                <v-list-item-title><a href="https://saulmamani.github.io" target="_blank">Saúl Mamani Mamani</a></v-list-item-title>
                <v-list-item-subtitle>Celular: 76137269 <br> Email: luas0_1@yahoo.es</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Javier Gonzales Chavarria</v-list-item-title>
                <v-list-item-subtitle>Celular: 76130830 <br> Email: luas0_1@yahoo.es</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Franco Jesus Mamani Pozo</v-list-item-title>
                <v-list-item-subtitle>Celular: 72464162 <br> Email: luas0_1@yahoo.es</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Daniel Alejandro Ojalvo Canedo</v-list-item-title>
                <v-list-item-subtitle>Celular: 72464162 <br> Email: luas0_1@yahoo.es</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

          </v-list>
        </v-card-text>
    </v-card>
</template>

<script>
  import EncabezadoCard from "../components/EncabezadoCard";

  export default {
    name: 'Home',
    components: {EncabezadoCard},
    data: () => ({}),
  }
</script>
